import React from 'react';
import { number, func, bool } from 'prop-types';
import { PrevIcon } from '@atoms';
import { Flex, Button } from '@mixins';
import { theme } from '@styles';

import { ReactComponent as Dropdown } from '@assets/svgs/Dropdown.svg';

import { ProgressBarContainer } from './styles';

const OnboardingProgress = ({ totalSteps, currentStep, onBack, onNext, isNextButtonDisabled }) => {
  return (
    <Flex
      position="fixed"
      bottom={0}
      left={0}
      right={0}
      width="100%"
      px={['20px', '30px', '40px', '60px']}
      py={['15px', '20px']}
      flexDirection="column"
      alignItems="center"
      backgroundColor={theme.color.white}>
      <ProgressBarContainer>
        {Array.from({ length: Math.max(1, totalSteps) }).map((step, i) => {
          const isFilled = i < currentStep;

          return (
            <Flex
              key={step}
              flex={1}
              height="10px"
              borderRadius="6px"
              backgroundColor={isFilled ? theme.color.mintMinded[900] : theme.color.gray[200]}
              overflow="hidden"
            />
          );
        })}
      </ProgressBarContainer>

      <Flex width="100%" maxWidth="1320px" alignItems="center" justifyContent="space-between">
        <Button fontSize={[12, 14, 16, 18]} onClick={onBack}>
          <PrevIcon SVG={Dropdown} color={theme.color.mintMinded[900]} height={['8px', '12px']} mr="8px" />
          Back
        </Button>
        <Button
          disabled={isNextButtonDisabled}
          fontSize={[12, 14, 16, 18]}
          variant="primary"
          py={[10, 12]}
          px={[40, 60, 80]}
          onClick={onNext}>
          Next
        </Button>
      </Flex>
    </Flex>
  );
};

OnboardingProgress.propTypes = {
  isNextButtonDisabled: bool.isRequired,
  totalSteps: number.isRequired,
  currentStep: number.isRequired,
  onBack: func.isRequired,
  onNext: func.isRequired,
};

export default OnboardingProgress;
